<style lang="css" scoped>

.info {
    list-style-type: none;
    margin: 0;
    padding: 0;
    overflow: hidden;
    border-radius: 10px;
    background-color: #333333;
    padding: 5px;
}

li {
    margin: 3px;
    display: inline-block;
}

card {
    border-width: 1px;
    border-color: #0000;
}

.card-body {
    min-width: 60%;
    max-height: 60%;
}

</style>

<template>

<div class="card" id="">
    <h6 class="card-header">Job History</h6>
    <div class="card-body">
        <v-card v-if="!filter" outlined>
            <v-chip @click:close="filters.jobID = null" v-if="filters.jobID" class="ma-2" color="red" text-color="white" close>
                ID: {{filters.jobID}}
            </v-chip>
            <v-chip @click:close="filters.customer = null" v-if="filters.customer" class="ma-2" color="primary" text-color="white" close>
                Customer: {{filters.customer}}
            </v-chip>
            <v-chip @click:close="filters.phone = null" v-if="filters.phone" class="ma-2" color="red" text-color="white" close>
                Phone: {{filters.phone}}
            </v-chip>
            <v-chip @click:close="filters.address = null" v-if="filters.address" class="ma-2" color="secondary" close>
                Address: {{filters.address}}
            </v-chip>
            <v-chip @click:close="filters.date = null" v-if="filters.date" class="ma-2" color="primary" close>
                Date: {{filters.date}}
            </v-chip>
            <v-chip @click:close="filters.make = filters.model = filters.year = null" v-if="filters.make && filters.model && filters.year" class="ma-2" color="green" text-color="white" close>
                Vehicle: {{filters.make}}-{{filters.model}}-{{filters.year}}
            </v-chip>
        </v-card>

        <b-table striped outlined staked="md" style="margin-top:10px" :items="items" :fields="fields" :per-page="perPage" :current-page="currentPage" id="my-table">

            <template v-if="row.item.job != null" slot="job" slot-scope="row">
                {{row.item.job.jobID}}
            </template>

            <template v-if="row.item.job.user != null" slot="technician" slot-scope="row">
                {{row.item.job.user.fname + " " + row.item.job.user.lname}}
            </template>
            <template v-if="row.item.job != null" slot="dispatcher" slot-scope="row">
                {{row.item.adminUser.username}}

            </template>
            <template v-if="row.item.job != null" slot="status" slot-scope="row">
                {{row.item.status}}
            </template>

            <template v-if="row.item.job != null" slot="from" slot-scope="row">
                {{getReadableTime(row.item.job.from)}}
            </template>

            <template v-if="row.item.job != null" slot="to" slot-scope="row">
                {{getReadableTime(row.item.job.to)}}
            </template>

            <template v-if="row.item.job != null" slot="date" slot-scope="row">
                {{getReadableDateTime(row.item.createDate)}}
            </template>

            <template slot="actions" slot-scope="row">
                <!-- We use @click.stop here to prevent a 'row-clicked' event from also happening -->
                <b-button size="sm" @click="rowClick(row.item.job)" variant="outline-primary" style="cursor:pointer;">
                    Details
                </b-button>

            </template>

        </b-table>
        <b-row>
            <b-col md="3"></b-col>
            <b-col md="6" class="my-1">
                <v-pagination v-model="currentPage" :length="length" @input="pageChange" :total-visible="6"></v-pagination>
            </b-col>
            <b-col md="3"></b-col>

            <v-btn @click="openFilter" absolute dark fab bottom right color="primary">
                <v-icon>mdi-filter</v-icon>
            </v-btn>

        </b-row>
    </div>

    <v-dialog v-if="job != null" v-model="details" transition="dialog-bottom-transition" fullscreen>

        <v-card fill-height>
            <v-toolbar dark dense color="primary">
                <v-btn icon dark @click="details = false">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
                <v-toolbar-title>Job Description</v-toolbar-title>
                <v-spacer></v-spacer>
            </v-toolbar>

            <v-container>
                <v-row style="height: 65px;">
                    <v-col cols="2" class="text-info">
                        Customer Details:
                    </v-col>
                    <v-col cols="4">
                        <v-text-field v-model="job.customer.fname +' '+ job.customer.lname" dense filled color="purple darken-2" readonly label="Customer Name:">
                        </v-text-field>
                    </v-col>
                    <v-col cols="1"></v-col>
                    <v-col cols="4">
                        <v-text-field v-model="job.customer.phone" dense filled readonly color="purple darken-2" label="Phone:" />
                    </v-col>
                </v-row>

                <v-row style="height: 65px;">
                    <v-col cols="2"></v-col>
                    <v-col cols="4">
                        <v-text-field v-model="job.customer.email" dense filled readonly color="purple darken-2" label="Email:" />
                    </v-col>
                    <v-col cols="1"></v-col>
                    <v-col cols="4">
                      <v-text-field v-model="job.customer.email" dense readonly filled color="purple darken-2" label="Email:">
                      </v-text-field>
                    </v-col>
                </v-row>

                <v-divider></v-divider>


                <v-row style="height: 65px;">
                    <v-col cols="2" class="text-info">
                        Job Details:
                    </v-col>
                    <v-col cols="4">
                        <v-text-field v-model="job.jobID" dense filled readonly color="purple darken-2" label="Job ID:" />
                    </v-col>
                    <v-col cols="1"></v-col>
                    <v-col cols="4">
                        <v-text-field v-model="job.status" dense filled readonly color="purple darken-2" label="Status:" />
                    </v-col>
                </v-row>


                <v-row v-for="type in job.jobTypes" style="height: 65px;">
                    <v-col cols="2"></v-col>
                    <v-col cols="4">
                        <v-text-field v-model="type.jobType" dense filled readonly color="purple darken-2" label="Job Type:" />
                    </v-col>
                    <v-col cols="1"></v-col>
                    <v-col cols="4">
                        <small class="text-info">Selected Vehicle:</small>
                        <div>
                            <v-chip class="ma-1" color="primary" text-color="white">
                                Make: {{job.vehicle.key.make}}
                            </v-chip>
                            <v-chip class="ma-1" color="primary" text-color="white">
                                Model: {{job.vehicle.key.model}}
                            </v-chip>
                            <v-chip class="ma-1" color="primary" text-color="white">
                                Year: {{job.vehicle.key.year}}
                            </v-chip>
                        </div>
                    </v-col>
                </v-row>

                <v-row v-for="type in job.jobTypes" v-if="type.item && type.item.item" style="height: 65px;">
                    <v-col cols="2"></v-col>
                    <v-col cols="6">
                        <small class="text-info">Selected Key:</small>
                        <div>
                          <v-avatar left>
                              <v-img :src="type.item.item.key.image"></v-img>
                          </v-avatar>
                            <v-chip class="ma-1" color="green" text-color="white">
                                OEM: {{type.item.item.key.oem}}
                            </v-chip>
                            <v-chip class="ma-1" color="green" text-color="white">
                                FCC: {{type.item.item.key.fcc}}
                            </v-chip>
                            <v-chip class="ma-1" color="green" text-color="white">
                                IC: {{type.item.item.key.ic}}
                            </v-chip>
                        </div>
                    </v-col>
                </v-row>

                <v-row v-for="type in job.jobTypes" style="margin-top:20px; height:60px">
                    <v-col cols="2" class="text-info">

                    </v-col>
                    <v-col cols="4">
                        <v-text-field v-model="'$'+type.quote" dense readonly filled color="purple darken-2" label="Quote:">
                        </v-text-field>
                    </v-col>
                </v-row>

                <v-divider style="margin-top:25px;"></v-divider>

                <v-row style="height: 65px;">
                    <v-col cols="2" class="text-info">
                        Time Details:
                    </v-col>
                    <v-col cols="4">
                        <v-text-field v-model="job.user.username" dense filled readonly color="purple darken-2" label="Technician:" />
                    </v-col>
                    <v-col cols="1"></v-col>
                    <v-col cols="4" v-if="">
                        <v-text-field v-model="getDate" dense filled readonly color="purple darken-2" label="Schedule Date:" />
                    </v-col>
                </v-row>

                <v-row style="height: 65px;">
                    <v-col cols="2"></v-col>
                    <v-col cols="2">
                        <v-text-field v-model="getStart" dense filled readonly color="purple darken-2" label="Start:" />
                    </v-col>
                    <v-col cols="2">
                        <v-text-field v-model="getEnd" dense filled readonly color="purple darken-2" label="End:" />
                    </v-col>
                    <v-col cols="1"></v-col>
                    <v-col cols="4">
                        <v-text-field v-model="job.address" dense filled readonly color="purple darken-2" label="Address:" />
                    </v-col>


                </v-row>

                <v-row style="height: 65px;">
                    <v-col cols="2"></v-col>
                    <v-col cols="4">
                        <v-text-field v-model="job.opRemarks" dense filled readonly color="purple darken-2" label="Remarks:" />
                    </v-col>
                    <v-col cols="1"></v-col>
                    <v-col cols="4">

                    </v-col>
                </v-row>

                <v-divider></v-divider>

                <div v-if="job.status == 'COMPLETED'">
                    <v-row style="height: 65px;">
                        <v-col cols="2" class="text-info">
                            Completition Details:
                        </v-col>
                        <v-col cols="4">
                            <v-text-field v-model="job.method" dense filled readonly color="purple darken-2" label="Payment Method:" />
                        </v-col>
                        <v-col cols="1"></v-col>
                        <v-col cols="4">
                            <v-text-field v-model="'$' + job.actual_price" dense filled readonly color="purple darken-2" label="Price:" />
                        </v-col>
                    </v-row>
                    <v-row v-if="job.caaCard" style="height: 65px;">
                        <v-col cols="2"></v-col>
                        <v-col cols="4">
                            <v-text-field v-model="job.caaCard.name" dense filled readonly color="purple darken-2" label="CAA Name:" />
                        </v-col>
                        <v-col cols="1"></v-col>
                        <v-col cols="2">
                            <v-text-field v-model="job.caaCard.number" dense filled readonly color="purple darken-2" label="CAA Number:" />
                        </v-col>
                        <v-col cols="2">
                            <v-text-field v-model="job.caaCard.type" dense filled readonly color="purple darken-2" label="CAA Type:" />
                        </v-col>
                    </v-row>
                    <v-row style="height: 65px;">
                        <v-col cols="2"></v-col>
                        <v-col cols="4">
                            <v-text-field v-model="job.vin" dense filled readonly color="purple darken-2" label="VIN:" />
                        </v-col>
                        <v-col cols="1">
                        </v-col>
                        <v-col cols="4">
                            <v-text-field v-model="job.used" dense filled readonly color="purple darken-2" label="Keys Used:" />
                        </v-col>
                    </v-row>

                    <v-row style="height: 65px;">
                        <v-col cols="2"></v-col>
                        <v-col cols="4">
                            <v-text-field v-model="job.techRemarks" dense filled readonly color="purple darken-2" label="Remarks:" />
                        </v-col>
                    </v-row>
                </div>
            </v-container>
        </v-card>
    </v-dialog>

    <v-dialog v-model="filter" max-width="500px">
        <v-card>
            <v-card-title>
                <span class="headline">Filter jobs</span>
            </v-card-title>
            <v-card-text>
                <v-container>
                    <v-row style="height: 50px;">
                        <v-text-field dense outlined label="Job ID:" v-model="filters.jobID"></v-text-field>
                    </v-row>
                    <v-divider></v-divider>
                    <v-row style="height: 50px;">
                        <v-text-field dense outlined label="Customer Name:" v-model="filters.customer"></v-text-field>
                    </v-row>
                    <v-row style="height: 50px;">
                        <v-text-field dense outlined label="Phone:" v-model="filters.phone"></v-text-field>
                    </v-row>
                    <v-divider></v-divider>
                    <v-row style="height: 50px;">
                        <v-text-field dense outlined label="Address:" v-model="filters.address"></v-text-field>
                    </v-row>
                    <v-row style="height: 50px;">
                        <v-menu ref="menu" v-model="menu" :close-on-content-click="false" :return-value.sync="filters.date" transition="scale-transition" offset-y max-width="290px" min-width="290px">
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field v-model="filters.date" label="Date" prepend-inner-icon="event" readonly v-bind="attrs" v-on="on" dense outlined></v-text-field>
                            </template>
                            <v-date-picker v-model="filters.date" no-title scrollable :show-current="true">
                                <v-spacer></v-spacer>
                                <v-btn text color="primary" @click="menu = false">Cancel</v-btn>
                                <v-btn text color="primary" @click="$refs.menu.save(filters.date)">OK</v-btn>
                            </v-date-picker>
                        </v-menu>
                    </v-row>
                    <v-divider></v-divider>
                    <v-row style="height: 50px;">
                        <v-col class="pa-0">
                            <v-select v-model="filters.make" :items="makes" @input="makeChange" label="Make" dense outlined :clearable="true"></v-select>
                        </v-col>
                        <v-col class="pa-0">
                            <v-select v-model="filters.model" :items="models" @input="modelChange" label="Model" dense outlined></v-select>
                        </v-col>
                        <v-col class="pa-0">
                            <v-select v-model="filters.year" :items="years" label="Year" dense outlined></v-select>
                        </v-col>
                    </v-row>

                </v-container>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="cancel">Cancel</v-btn>
                <v-btn color="blue darken-1" text @click="fetch">Filter</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>

</div>

</template>

<script>

export default {
    created() {
            this.$overlay.show(this)
            this.$api
                .getJobHistory(this.filters)
                .then(res => {
                    if (res.status == 200) {
                        this.items.push(...res.data.content)
                    }
                    this.$overlay.hide()
                })
                .catch(er => {
                    this.$overlay.hide()
                })
        },
        computed: {
            getDate: {
                get() {
                        return this.getReadableDate(this.job.date);
                    },
                    set(val) {}
            },
            getStart: {
                get() {
                        return this.getReadableTime(this.job.from);
                    },
                    set(val) {}
            },
            getEnd: {
                get() {
                        return this.getReadableTime(this.job.to);
                    },
                    set(val) {}
            },
            length() {
                return Math.trunc(this.rows() / 6 + 1);
            }

        },
        watch: {
            "filters.customer": function(newVal, oldVal) {
              if(!this.filter)
                this.fetch();
            },
            "filters.phone": function(newVal, oldVal) {
              if(!this.filter)
                  this.fetch();
            },
            "filters.address": function(newVal, oldVal) {
              if(!this.filter)
                this.fetch();
            },
            "filters.make": function(newVal, oldVal) {
              if(!this.filter)
                this.fetch();
            },
            "filters.date": function(newVal, oldVal) {
              if(!this.filter)
                this.fetch();
            },
            "filters.jobID": function(newVal, oldVal) {
              if(!this.filter)
                this.fetch();
            }
        },
        data: () => ({
            items: [],
            fields: [{
                key: 'job',
                label: 'Job ID'
            }, 'technician', 'dispatcher', 'status', 'date', 'actions'],
            statuses: ['COMPLETED', "ASSIGNED", "RESCHEDULED"],
            makes: [],
            models: [],
            years: [],
            perPage: 6,
            currentPage: 1,
            job: null,
            details: false,
            filter: false,
            menu: false,
            filters: {
                page: 0
            }
        }),
        methods: {
            rows() {
                    return this.items.length
                },
                rowClick(job) {
                    this.job = job;
                    this.details = true;
                },
                pageChange(page) {
                    let isLastPage = this.rows() / this.perPage;
                    this.filters.page = page - 1;
                    if (page >= isLastPage)
                        this.$api
                        .getJobHistory(this.filters)
                        .then(res => {
                            if (res.status == 200) {
                                if (page == 1) this.items = res.data.content
                                else this.items.push(...res.data.content)
                            }
                        })
                        .catch(er => {})
                },
                getReadableDateTime(date) {
                    var options = {
                        year: 'numeric',
                        month: 'numeric',
                        day: 'numeric',
                        hour: 'numeric',
                        minute: 'numeric'
                    }
                    return new Date(date).toLocaleDateString('en-US', options)
                },
                getReadableTime(date) {
                    let d = new Date(date).toUTCString()
                    let hours = d.substring(17, 19)
                    let minutes = d.substring(20, 22)
                    return this.formatAMPM(hours, minutes)
                },
                formatAMPM(hours, minutes) {
                    var ampm = hours >= 12 ? 'PM' : 'AM'
                    hours = hours % 12
                    hours = hours ? hours : 12 // the hour '0' should be '12'
                    var strTime = hours + ':' + minutes + ' ' + ampm
                    return strTime
                },
                getReadableDate(date) {
                    var options = {
                        year: 'numeric',
                        month: 'numeric',
                        day: 'numeric'
                    }
                    return new Date(date).toLocaleDateString('en-US', options)
                },
                fetch() {
                    this.filter = false;
                    this.filters.page = 0;
                    this.items = [];
                    this.$overlay.show(this)
                    this.$api
                        .getJobHistory(this.filters)
                        .then(res => {
                            if (res.status == 200) {
                              this.items.push(...res.data.content)
                            }
                            this.$overlay.hide()
                        })
                        .catch(er => {
                            this.$overlay.hide()
                        })
                },
                makeChange() {
                    if (this.filters.make != null) {
                        this.$api.getModels(this.filters.make).then(response => {
                            if (response.status == 200) {
                                this.models = response.data
                            }
                        })
                    }
                },
                modelChange() {
                    this.filters.year = ''
                    if (this.filters.make != null && this.filters.model != null) {
                        this.$api.getYears(this.filters.make, this.filters.model).then(response => {
                            if (response.status == 200) {
                                this.years = response.data
                            }
                        })
                    }
                },
                cancel(){
                  this.filters.make = this.filters.model = this.filters.year = null;
                  this.filter = false;
                },
                openFilter(){
                  if (this.makes != null)
                      this.$api
                      .getMakes()
                      .then(response => {
                          if (response.status == 200) {
                              this.makes = response.data
                          }
                      })
                      .catch(error => {})
                  this.filter = true;
                }

        }
}

</script>
